import type { TFunction } from '@cobliteam/i18n';

const unhandledUnassignedError = (unassigned: any[], t: TFunction) => {
  const ids = unassigned.map((entry: any) => `"${entry.id}"`).join(', ');
  return t('routing_optimization.errors.unhandled', { ids });
};

export const parseRoutingErrors = (error: any, t: TFunction): string => {
  const response = error?.graphQLErrors?.[0]?.extensions?.response;
  const unassigned = Array.isArray(response?.body?.unassigned) ? response.body.unassigned : undefined;

  if (response) {
    switch (response.status) {
      case 422:
        if (unassigned) {
          return parseUnprocessableEntityError(false, t, unassigned) || unhandledUnassignedError(unassigned, t);
        }
        return t('routing_optimization.errors.generic');
      default:
        break;
    }
  }

  return t('routing_optimization.errors.generic');
};

export const parseUnprocessableEntityError = (isUpdateRequest: boolean, t: TFunction, unassigned?: any[]): string | undefined => {
  if (unassigned) {
    const unassignedCounted = unassignedReasonCodeCount(unassigned);

    const hasErrorCode50 = unassignedCounted.find((entry: any) => entry.reason_code === 50);
    const entriesCode50 = unassigned.filter((entry: any) => entry.reason_code === 50);
    const hasErrorCode21 = unassignedCounted.find((entry: any) => entry.reason_code === 21);
    const hasErrorCode2 = unassignedCounted.find((entry: any) => entry.reason_code === 2);
    const hasErrorCode3 = unassignedCounted.find((entry: any) => entry.reason_code === 3);

    if (hasErrorCode50) {
      return reasonCode50(hasErrorCode50, entriesCode50, t, isUpdateRequest);
    }

    if (hasErrorCode21 || hasErrorCode2) {
      return t('routing_optimization.errors.journey_exceeded');
    }

    if (hasErrorCode3) {
      return t('routing_optimization.errors.no_vehicle_capacity');
    }
  }
};

const reasonCode50 = (error50: any, entriesCode50: any[], t: TFunction, isUpdateRequest: boolean) => {
  const action = isUpdateRequest ? t('routing_optimization.errors.action_update') : t('routing_optimization.errors.action_create');

  if (error50.count > 1) {
    const ids = entriesCode50.map((entry: any) => `"${entry.id}"`).join(', ');
    return t('routing_optimization.errors.inaccessible_multiple', { action, ids });
  }

  return t('routing_optimization.errors.inaccessible_single', { action, ids: `"${error50.id}"` });
};

const unassignedReasonCodeCount = (unassigned: any) => {
  const unassignedCount: any = {};

  unassigned.forEach((entry: any) => {
    const key = entry.reason_code;

    if (!unassignedCount[key]) {
      unassignedCount[key] = {
        ...entry,
        count: 0,
      };
    }

    unassignedCount[key].count += 1;
  });

  return Object.values(unassignedCount);
};
